import image1 from '../../assets/images/products/PanDeLeche.jpg';
import image2 from '../../assets/images/products/HAMBURGUESA.jpg';
import noimage from '../../assets/images/no-imagen.svg';
import image5 from '../../assets/images/products/PERRO-NY.jpg';
import image6 from '../../assets/images/products/PERRO.jpg';
import image9 from '../../assets/images/products/BOLILLO.jpg';
import image10 from '../../assets/images/products/CANILLA.jpg';
import image11 from '../../assets/images/products/CUBANO.jpg';
import image12 from '../../assets/images/products/IBERICO.jpg';
import image14 from '../../assets/images/products/PULLMAN-ENTERO.jpg';

export const PRODUCTS = [
    {
        name: "PAN DE LECHE MEDIO MOLDE",
        unit: 1,
        peso: "400",
        medida: "25",
        image: image1,
        description: (
            <p>
                Este pan de leche medio molde es una opción perfecta para cualquier momento del día. Su
                textura suave y cremosa, junto con su rico sabor a leche de alta calidad, lo convierten en una
                experiencia culinaria única. Además, su forma cuadrada, resultado de su cocción en sartén,
                lo hace diferente y especial. <br />
                Ya sea para disfrutarlo en el desayuno, la merienda o como acompañamiento de tus comidas,
                este pan de leche es una elección que no te decepcionará. Sorprende a tu paladar tostándolo
                y untándole mantequilla o mermelada, o úsalo como base para crear deliciosos sándwiches.
                No pierdas la oportunidad de probar este exquisito pan de leche medio molde, hecho con una
                miga suave y alta concentración de leche, que te brindará una experiencia gastronómica
                única y diferente. ¡Te invitamos a deleitar tus sentidos con su sabor y textura únicos!
            </p>),
    },
    {
        name: "PAN HAMBURGUESA",
        unit: 1,
        peso: "80",
        medida: "10",
        image: image2,
        description: (
            <p>
                "¿Estás buscando el pan perfecto para acompañar tu hamburguesa favorita? ¡Tenemos la solución para ti! Prueba nuestro delicioso pan de masa suave, especialmente diseñado para complementar el sabor de una jugosa hamburguesa.<br />
                Este pan está horneado con los ingredientes de la más alta calidad, creando una textura suave y esponjosa que se deshace en tu boca con cada mordisco. Además, nuestra receta incluye un toque de ajonjolí en la corteza, lo que le da un sabor único y una apariencia atractiva.<br />
                Nuestro pan de hamburguesa es la elección perfecta para cualquier ocasión, ya sea que estés disfrutando de una barbacoa con amigos, comiendo en tu restaurante de hamburguesas favorito o simplemente preparando una cena rápida en casa. El sabor y la textura de nuestro pan seguramente impresionarán a tus amigos y familiares, y se convertirá en un complemento esencial para tu hamburguesa. <br />
                Así que, ¿por qué conformarte con cualquier pan para hamburguesas? Prueba nuestro pan de masa suave con ajonjolí y descubre una nueva dimensión de sabor en tu hamburguesa favorita. ¡Te garantizamos que no te arrepentirás!"
            </p>)
    },
    {
        name: "PAN BUNS",
        unit: 1,
        peso: "80",
        medida: "10",
        image: noimage,
        description: (<p>
            ¡Prepárate para deleitar tus sentidos con nuestros deliciosos Pan Buns! Este pan redondo de
            masa suave es la adición perfecta para cualquier comida.<br />
            Con su textura suave y esponjosa, nuestros Pan Buns son ideales para acompañar cualquier
            menú. Su sabor ligero y neutro se adapta perfectamente a cualquier plato, ya sea una ham-
            burguesa jugosa, una sopa caliente o una ensalada fresca.<br />
            Además, nuestros Pan Buns son perfectos para aquellos que prefieren opciones de pan más
            suaves y menos densas. Cada bocado es una experiencia única, que se deshace en la boca y
            te deja con un delicioso sabor a pan fresco.<br />
            Nuestro compromiso con la calidad significa que solo usamos los mejores ingredientes para
            hacer nuestros Pan Buns. Cada lote se hornea con cuidado para asegurar que cada pan esté
            perfectamente cocido y listo para ser disfrutado.<br />
            Si estás buscando un pan versátil, suave y delicioso, nuestros Pan Buns son la elección
            perfecta. Haz que cada comida sea aún más deliciosa con nuestros deliciosos Pan Buns.
        </p>),
    },
    {
        name: "PAN DE VIENA",
        unit: 1,
        peso: "80",
        medida: "22",
        image: noimage,
        description: (<p>
            ¡Bienvenido al delicioso mundo del pan de Viena elaborado con mantequilla y con una forma
            alargada y cortes en su corteza!<br />
            Si eres un amante del pan, nuestro pan de Viena es una experiencia que no te puedes perder.
            Su miga suave y esponjosa, su corteza crujiente y sus cortes en forma de diamante que real-
            zan su belleza, hacen que sea el acompañante perfecto para cualquier comida.<br />
            Nuestro pan de Viena es elaborado con mantequilla, lo que le da un sabor suave y cremoso
            que se funde en tu boca. Además, su forma alargada y sus cortes en la corteza, no solo le dan
            un aspecto visualmente atractivo, sino que también permiten que el pan se hornee de manera
            uniforme, obteniendo así una textura suave y esponjosa en todo el pan.<br />
            En nuestra panadería, nos tomamos el tiempo para asegurarnos de que cada pan de Viena
            esté hecho con los mejores ingredientes y la técnica de horneado adecuada, lo que resulta en
            un sabor inigualable y una textura perfecta.<br />
            Si buscas un pan de alta calidad para acompañar tus comidas, nuestro pan de Viena elabora-
            do con mantequilla y con forma alargada y cortes en su corteza es la elección perfecta.
            Prueba uno hoy y déjate seducir por su sabor y textura irresistibles.
        </p>),
    },
    {
        name: "PAN MEDIA NOCHE",
        unit: 1,
        peso: "80",
        medida: "20",
        image: noimage,
        description: (<p>
            ¿Te apetece probar un pan que te transporta a la Cuba de antaño? Conoce el delicioso pan
            media noche, un pan cubano de masa suave con forma alargada y extremos finos.<br />
            Su nombre se debe a que, según los historiadores, era un pan que se comía a media noche, y
            su sabor y textura lo hacen perfecto para cualquier momento del día. Este pan es ideal para
            hacer sándwiches, tostadas o simplemente disfrutarlo solo.<br />
            Su masa suave y esponjosa es el resultado de la combinación perfecta de ingredientes fres-
            cos y cuidadosamente seleccionados. Y su forma alargada con extremos finos lo hacen fácil
            de partir y perfecto para compartir con amigos y familiares.<br />
            El pan media noche es una deliciosa opción para cualquier ocasión, desde un picnic en el
            parque hasta una cena elegante en casa. No esperes más para probarlo y experimentar el
            auténtico sabor de la cocina cubana. ¡Hazte con tu pan media noche y disfruta de una expe-
            riencia gastronómica única!
        </p>),
    },
    {
        name: "PAN PERRO",
        unit: 1,
        peso: "80",
        medida: "22",
        image: image6,
        description: (<p>
            ¿Quieres experimentar el auténtico sabor de un hot dog? Entonces no busques más allá de
            nuestro pan perro pan típico para hot dog.<br />
            Con su textura suave y esponjosa y su delicioso sabor, este pan es el complemento perfecto
            para cualquier hot dog. Hecho con ingredientes de la más alta calidad, cada bocado es una
            explosión de sabor que dejará a tus papilas gustativas pidiendo más.<br />
            Ya sea que lo disfrutes con ketchup, mostaza, relish o cualquier otra combinación de condi-
            mentos, nuestro pan perro pan típico para hot dog es la opción perfecta para los amantes de
            los hot dogs en todo el mundo.<br />
            Así que no esperes más para probar nuestro pan perro pan típico para hot dog y descubre por
            qué es la opción preferida de los conocedores de hot dogs en todo el mundo. ¡Ordénalo ahora
            y experimenta la diferencia!
        </p>),
    },
    {
        name: "PAN PERRO NEW YORK",
        unit: 1,
        peso: "80",
        medida: "22",
        image: image5,
        description: (
            <p>
                ¡El pan perro al estilo de Nueva York ha llegado a Cuba con un toque especial de ajonjolí!
                Imagínate disfrutando de un delicioso pan perro recién horneado, con un sabor auténtico y un
                toque de ajonjolí tostado en la parte superior. Este pan perro es la combinación perfecta de
                suave y esponjoso por dentro, y crujiente por fuera.<br />
                La auténtica receta de pan perro estilo Nueva York, que ha sido llevada a Cuba, ahora se ha
                enriquecido con el sabor único del ajonjolí. Este ingrediente no solo aporta un toque extra de
                sabor, sino que también mejora la textura y el aspecto del pan.<br />
                Este pan perro con ajonjolí es una deliciosa opción para cualquier ocasión. Ya sea que lo
                disfrutes solo con tus condimentos favoritos, o lo combines con ingredientes cubanos tradi-
                cionales como la carne de cerdo asada, esta versión del pan perro te sorprenderá con su
                sabor auténtico.<br />
                En resumen, el pan perro estilo Nueva York con ajonjolí es una opción perfecta para aquellos
                que buscan un bocado sabroso y auténtico con un toque especial cubano. Prueba uno hoy y
                descubre por ti mismo la combinación perfecta de sabores. ¡No te arrepentirás!
            </p>),
    },
    {
        name: "PAN BARRA SUAVE SABORIZADAS (NATURAL, AJO, ALBAHACA)",
        unit: 1,
        peso: "250",
        medida: "35",
        image: noimage,
        description: (
            <p>
                Si eres un amante del pan y te encanta probar nuevos sabores, ¡nuestro pan de barra suave
                saborizadas es perfecto para ti!<br />
                Disponible en tres deliciosas opciones de sabor: natural, ajo y albahaca, nuestro pan de barra
                suave es el acompañamiento perfecto para cualquier comida. Elaborado con ingredientes de
                la más alta calidad, nuestro pan de barra suave saborizadas es suave y esponjoso, lo que lo
                hace ideal para sándwiches, tostadas y cualquier otra receta que se te ocurra.<br />
                Si prefieres un sabor suave y neutro, nuestra opción natural es perfecta para ti. Pero si te
                encanta el ajo, ¡prueba nuestro pan de barra suave con sabor a ajo! El intenso sabor a ajo le
                da a este pan un toque único y delicioso. Y si prefieres sabores más frescos, nuestro pan de
                barra suave con sabor a albahaca te sorprenderá con su aroma y sabor.<br />
                Ya sea que estés disfrutando de una cena en familia o de una reunión con amigos, nuestro
                pan de barra suave saborizadas es el acompañamiento perfecto. Además, ¡nuestro pan es
                muy versátil! Puedes utilizarlo para hacer deliciosos sándwiches, bruschettas, tostadas fran-
                cesas y mucho más.<br />
                Prueba los tres sabores y descubre tu favorito. ¡No te arrepentirás de probar nuestro pan de
                barra suave saborizadas con ajo o albahaca!
            </p>),
    },
    {
        name: "BONETTE",
        unit: 1,
        peso: "250",
        medida: "20",
        image: noimage,
        description: (
            <p>
                ¡Descubre el sabor suave y la textura deliciosa del Bonette! Este pan redondo de alto gramaje
                se distingue por su mezcla única de ingredientes, con una generosa adición de leche y huevo
                que lo hace especialmente suave y tierno.<br />
                Si eres un amante del pan, el Bonette es una elección perfecta. Su textura agradable y sabor
                suave lo convierten en una opción ideal para cualquier momento del día. Ya sea que lo disfru-
                tes en el desayuno, el almuerzo o la cena, el Bonette te hará sentir como si estuvieras comien-
                do en un restaurante de alta cocina.<br />
                La calidad y el sabor de los ingredientes que usamos en la elaboración del Bonette es lo que
                lo hace tan especial. Nuestro pan se hornea diariamente con los ingredientes más frescos y
                de la más alta calidad, para garantizarte una experiencia de sabor única y satisfactoria.
                Disfruta del Bonette por sí solo, o utilízalo como base para tus bocadillos favoritos. Sea cual
                sea tu elección, estamos seguros de que no podrás
                resistirte a su suave textura y sabor exquisito.<br />
                Así que no esperes más, prueba el Bonette hoy mismo y descubre por qué es uno de los
                panes favoritos de todos los tiempos. ¡Te garantizamos que no te arrepentirás!
            </p>),
    },
    {
        name: "BOCADITOS",
        unit: 1,
        peso: "20",
        medida: "3",
        image: noimage,
        description: (
            <p>
                ¡Disfruta de los bocaditos panecitos más deliciosos en tu próxima celebración de cumplea-
                ños! Estos pequeños manjares son el acompañamiento perfecto para cualquier pasta de
                bocaditos, y son una opción popular en todo tipo de eventos festivos.<br />
                Cada panecito está hecho con ingredientes frescos y de alta calidad, y se hornea con cuidado
                para obtener una textura perfectamente esponjosa. Disponibles en una variedad de sabores,
                desde clásicos como el pan blanco y el pan integral, hasta opciones más exóticas como el
                pan de ajo o el pan de queso.<br />
                Ya sea que estés organizando una fiesta de cumpleaños infantil o un evento más formal, los
                bocaditos panecitos son una excelente opción para satisfacer a tus invitados. Acompáñalos
                con una deliciosa pasta de bocaditos, y tus invitados estarán encantados con la combinación
                de sabores y texturas.<br />
                No te conformes con bocadillos aburridos y sin sabor en tu próxima celebración. Asegúrate
                de ofrecer a tus invitados los mejores bocaditos panecitos, hechos con ingredientes frescos
                y un toque de amor en cada bocado. ¡Haz que tu evento sea inolvidable con estos deliciosos
                y versátiles bocaditos!
            </p>),
    },
    {
        name: "BOLILLO",
        unit: 1,
        peso: "80",
        medida: "20",
        image: image9,
        description: (
            <p>
                ¡Disfruta del delicioso sabor y textura única del bolillo mexicano! El bolillo es un pan tradicio-
                nal con una corteza crujiente y dorada que se deshace en tu boca, y una miga suave y espon-
                josa que te dejará con ganas de más.<br />
                Este pan de origen mexicano es perfecto para preparar tortas, sandwiches, o simplemente
                disfrutarlo recién horneado con un poco de mantequilla. Ya sea que lo consumas en el desa-
                yuno, almuerzo o cena, el bolillo es un pan versátil que siempre te dejará satisfecho.
                Además, su forma alargada y curva lo hace fácil de sostener y perfecto para compartir con
                amigos y familiares. Disfrútalo como quieras, el bolillo siempre será una opción deliciosa y
                auténtica.<br />
                Así que no esperes más para probar este pan tradicional mexicano. Prueba el bolillo y experi-
                menta el sabor y la textura que solo este pan puede ofrecer. ¡Buen provecho!
            </p>),
    },
    {
        name: "CANILLA",
        unit: 1,
        peso: "150",
        medida: "30",
        image: image10,
        description: (
            <p>
                ¿Estás buscando una deliciosa opción de pan para agregar a tu dieta diaria? ¡El canilla es la
                respuesta perfecta! Originario de Venezuela, este pan alargado tiene una corteza dura y está
                elaborado con manteca para un sabor y textura inigualables.<br />
                No solo es delicioso, sino que el canilla también se considera una dieta obligatoria en Vene-
                zuela, ¡lo que significa que es una opción saludable y nutritiva para incorporar en tus comidas
                diarias! Prueba el canilla como acompañamiento para tus platos favoritos, como sopas,
                ensaladas y carnes.<br />
                El canilla también es ideal para hacer deliciosos bocadillos y sándwiches. Agrega tus ingre-
                dientes favoritos y disfruta de un bocado lleno de sabor y textura crujiente.<br />
                ¿Por qué conformarse con un pan aburrido cuando puedes disfrutar del delicioso y auténtico
                sabor del canilla? Prueba este pan tradicional venezolano hoy mismo y descubre por qué es
                una de las opciones de pan más populares en todo el mundo.
            </p>),
    },
    {
        name: "CUBANO",
        unit: 1,
        peso: "200",
        medida: "30",
        image: image11,
        description: (
            <p>
                ¿Has probado alguna vez el auténtico pan cubano, también conocido como "pan de flauta"?
                Este pan tradicional de Cuba tiene una corteza crujiente y una miga alveolada que lo hacen
                irresistible para cualquier amante del pan.<br />
                El pan de flauta debe su nombre a su forma alargada y delgada, similar a la de una flauta.
                Además, su corte longitudinal representa la tira de guano que se solía colocar en el pasado
                en los techos de las casas para protegerlas del sol y la lluvia. Es un verdadero símbolo de la
                cultura cubana.<br />
                El proceso de elaboración del pan de flauta es todo un arte. Se utiliza harina de trigo de alta
                calidad y se amasa cuidadosamente hasta conseguir una masa suave y elástica. Después se
                deja reposar para que fermente y aumente su volumen, y finalmente se hornea a alta tempera-
                tura para obtener esa corteza crujiente y dorada que lo caracteriza.<br />
                ¿Te imaginas disfrutando de un bocadillo relleno de jamón y queso o un simple pero delicioso
                trozo de pan de flauta recién horneado con un poco de mantequilla? ¡No esperes más para
                probarlo y descubrir por qué el pan de flauta es un tesoro culinario de Cuba!
            </p>),
    },
    {
        name: "IBERICO",
        unit: 1,
        peso: "200",
        medida: "45",
        image: image12,
        description: (
            <p>
                ¡Bienvenidos amantes del buen pan! Si eres un apasionado del sabor y la textura del pan ibéri-
                co, entonces estás en el lugar correcto. Te presentamos el auténtico pan de barra tipo baguet-
                te, que evoca la tradición y el sabor del pan que se consume en gran medida en España.<br /><br />
                El pan ibérico es conocido por su aroma y sabor únicos, resultado de la combinación perfecta
                de harina, levadura y agua, junto con una cuidadosa fermentación y horneado. El pan de barra
                tipo baguette es el formato ideal para disfrutar de ese
                sabor característico en cualquier momento y lugar.<br /><br />
                Cada bocado de nuestro pan ibérico es una experiencia gastronómica incomparable, que te
                transporta a los campos de trigo dorado y los hornos tradicionales de las panaderías más
                auténticas de España. Con su corteza dorada y crujiente, y su miga suave y esponjosa, este
                pan es perfecto para acompañar cualquier plato, desde embutidos y quesos hasta ensaladas y sopas.<br /><br />
                Nuestro pan ibérico es elaborado con ingredientes de la más alta calidad y siguiendo los
                métodos más tradicionales, lo que asegura su sabor inconfundible y su textura perfecta.
                Además, está libre de conservantes y aditivos artificiales, por lo que puedes disfrutarlo con
                total confianza y seguridad.<br /><br />
                Si eres un verdadero amante del pan ibérico, no puedes perderte esta oportunidad de probar
                el auténtico pan de barra tipo baguette, que rinde homenaje a la rica tradición del pan en
                España. ¡Prueba nuestro pan hoy y descubre por qué es considerado uno de los mejores
                panes del mundo!
            </p>),
    },
    {
        name: "BAGUETTE PRE-COCIDO",
        unit: 1,
        peso: "80",
        medida: "25",
        image: noimage,
        description: (
            <p>
                ¿Quieres disfrutar del delicioso sabor de una auténtica baguette francesa recién horneada en
                la comodidad de tu hogar? ¡Prueba nuestro pan baguette pre-cocido tradicional!<br />
                Este pan baguette se distribuye congelado y pre-cocido para que puedas hornearlo en casa y
                disfrutar del aroma y sabor recién horneado que solo una auténtica baguette francesa puede
                ofrecer. Su textura crujiente y suave, su corteza dorada y su interior esponjoso te transporta-
                rán directamente a las calles de París.<br />
                Elaborado con los mejores ingredientes y siguiendo una receta tradicional, nuestro pan
                baguette pre-cocido es la opción perfecta para aquellos que buscan un pan de alta calidad,
                sin conservantes ni aditivos artificiales. Además, su formato pre-cocido y congelado te
                permite tener siempre a mano una opción deliciosa y versátil para cualquier momento del día.
                Prueba nuestro pan baguette pre-cocido tradicional y descubre por qué es la elección perfec-
                ta para aquellos que buscan calidad, sabor y comodidad en un solo producto.
            </p>),
    },
    {
        name: "PAN PULLMAN TRADICIONAL",
        unit: 30,
        peso: "750",
        medida: "30",
        image: image14,
        description: (
            <p>
                ¡Prueba nuestro delicioso pan de molde de corteza dorada y miga blanca, diseñado especial-
                mente para hacer los mejores sándwiches!<br />
                Nuestro pan se elabora cuidadosamente en un sartén molde cuadrado con tapa, lo que le da
                su forma única y perfecta para preparar los sándwiches más sabrosos. Además, su corteza
                dorada le da un toque de crujiente extra, mientras que su miga blanca esponjosa se funde en
                la boca con cada bocado.<br />
                ¿Te imaginas un sándwich hecho con nuestro pan de molde? ¡Te aseguramos que será una
                experiencia que nunca olvidarás! Es perfecto para cualquier combinación que se te ocurra,
                desde clásicos como jamón y queso, hasta opciones más creativas con aguacate, pollo a la
                parrilla o verduras asadas.<br />
                No esperes más para probar el mejor pan de molde para tus sándwiches. ¡Haz de tus comi-
                das algo especial con nuestro pan de molde de corteza dorada y miga blanca!
            </p>),
    },
    {
        name: "PAN PULLMAN CERO-CERO",
        unit: 30,
        peso: "750",
        medida: "30",
        image: image14,
        description: (
            <p>
                ¡Disfruta del sabor del pan fresco sin preocupaciones con el pan Pullman Cero-Cero! Este pan
                de molde sin azúcar ni grasas añadidas es la opción perfecta para aquellos que buscan
                cuidar su salud y mantener una alimentación equilibrada.<br />
                Con su textura suave y esponjosa, el pan Pullman Cero-Cero es una deliciosa alternativa para
                el desayuno, la merienda o cualquier comida del día. Además, su proceso de elaboración se
                realiza con ingredientes de calidad, lo que garantiza un producto fresco y saludable en cada
                rebanada.<br />
                ¡Cuida de ti y de los tuyos sin sacrificar el sabor con el pan Pullman Cero-Cero!
            </p>),
    },

];
